<style>
  .footer {
   position: relative;
   left: 0;
   bottom: 0;
   width: 100%;
   text-align: center;
}
</style>
<footer class="footer bg-light p-3 text-center">
    <p>
      Copyright ©{{currentYear}} Invested Enterprise, All rights reserved
    </p>
</footer>
